import { MenuItem } from "primeng/api";
import { IFooterLinks } from "../interfaces/IFooter";
import { environment } from "../../environments/environment";
import { IAlertCardContent } from "../interfaces/IAlertCard";
import { APP_ROUTES } from "./route.constant";
import { FormatPhonePipe } from "../components/shared/pipes/format-phone.pipe";
export const emailRegex = /^[a-zA-Z0-9](?:[a-zA-Z0-9._%+-]*[a-zA-Z0-9])?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
export const phoneRegex = /^(?:\+1\s?)?(?:\(?[2-9][0-9]{2}\)?[\s.-]?)?[2-9][0-9]{2}[\s.-]?[0-9]{4}$/;
export const zipCodeRegex = /^\d+$/;
export const phoneRegexWithFormat = /^(?:\+1|1)?[ .-]?\(?(?!(?:0|1))[2-9](?!11)\d{2}\)?[ .-]?\d{3}[ .-]?\d{4}$/;
export const nonDigitRegex = /\D/g;
export enum LogoType {
  Sears = 'SEARS',
  GoodMan = 'GOODMAN',
  Txu = 'TXUE',
  Cinch = 'CINCH',
};

export enum SERVICE_REQUEST_STATUS {
  ACTION_REQ = 'Action required',
  CANCELLED = 'Service request cancelled',
  COMPLETED = 'Service request completed',
  PM_CANCELLED = 'Cancelled',
};

export const SEVERITY = {
  WARN: 'warn',
  SUCCESS: 'success',
  SECONDARY: 'secondary',
  DANGER: 'danger',
} as const;
/// using const to make this as readonly SEVERITY: { readonly WARN: 'warn'; readonly SUCCESS: 'success'; readonly SECONDARY: 'secondary' }

export const SiteParamsValues = {
  sears: 'shw',
  goodman: 'ghw',
  txu: 'txu',
  remax: 'remax'
}
export const ClientIdForLogos = {
  sears: 'SEARS',
  ghs: 'GHS',
  ghp: 'GHP',
  txu: 'TXUE',
}
export const LogoClassNames = {
  CINCH_SEARS: 'cinch-sears-icon-logo',
  CINCH_GOODMAN: 'cinch-goodman-icon-logo',
  CINCH_TXU: 'cinch-txu-icon-logo',
  CINCH_REMAX: 'remax-logo',
  CINCH_DEFAULT: 'cinch-icon-logo'
};
export const Site = 'site';

export const footerLinkUrlLabel = {
  disclosuresUrl: 'disclosures',
  prinacyPolicyUrl: 'privacy-policy',
  termsUrl: 'terms-of-use',
}

export const MENU_LABELS = {
  home: 'Home',
  myPlan: 'My Plan',
  myServiceRequests: 'My Service Requests',
  payments: 'Payments',
  perksBenefits: 'Perks & Benefits',
  profileSettings: 'Profile Settings',
  contactUs: 'Contact Us',
}

export const navMenu: MenuItem[] = [
  {
    items: [
      {
        label: MENU_LABELS.home,
        icon: 'pi pi-home',
        route: '/dashboard'
      },
      {
        label: MENU_LABELS.myPlan,
        icon: 'pi pi-copy',
        route: '/my-plan'
      },
      {
        label: MENU_LABELS.myServiceRequests,
        icon: 'pi pi-calendar-clock',
        route: '/my-service-requests'
      },
      {
        label: MENU_LABELS.payments,
        icon: 'pi pi-wallet',
        route: '/payments'
      },
      {
        label: MENU_LABELS.perksBenefits,
        icon: 'pi pi-verified',
        route: '/perks-and-benefits'
      },
      {
        label: MENU_LABELS.profileSettings,
        icon: 'pi pi-cog',
        route: '/profile'
      },
      {
        label: MENU_LABELS.contactUs,
        icon: 'pi pi-question-circle',
        route: '/contact-us'
      },
    ]
  }
];

export const SPECIAL_BENEFITS_CONTACT_NUMBERS: Record<string, { phoneNumber: string; groupNumber: string | null }> = {
  'HIDR500': {
    phoneNumber: '8008598231',
    groupNumber: 'HPI-040114',
  },
  'HIDR1000': {
    phoneNumber: '8008598231',
    groupNumber: 'HPI-040114',
  },
  'DEDUCT': {
    phoneNumber: '8008598231',
    groupNumber: 'HPI-030112',
  },
  'EMERLDG': {
    phoneNumber: '8008598231',
    groupNumber: 'HPI-040114',
  },
  'SURGE-500': {
    phoneNumber: '8007114280',
    groupNumber: null,
  },
  'SURGE-1000': {
    phoneNumber: '8007114280',
    groupNumber: null,
  },
  'CSURGE-500': {
    phoneNumber: '8007114280',
    groupNumber: null,
  },
  'CSURGE-1000': {
    phoneNumber: '8007114280',
    groupNumber: null,
  },
  'CSURGE-1500': {
    phoneNumber: '8007114280',
    groupNumber: null,
  },
  'CSURGE-2000': {
    phoneNumber: '8007114280',
    groupNumber: null,
  },
  'CSURGE-5000': {
    phoneNumber: '8007114280',
    groupNumber: null,
  },
  'CSURGE-10000': {
    phoneNumber: '8007114280',
    groupNumber: null,
  },
  'PMRMBS100': {
    phoneNumber: '8443245688',
    groupNumber: null,
  }
};

export const PM_REIMBURSEMENT_ITEM_CODE = 'PMRMBS100';

export const BYOP_PLAN = 'BYOP';
export const SRG = 'SRG';
export const TXSRG = 'TXSRG';
export const SRG_PLANS = [SRG, TXSRG]; //SRG Is cinch surge plan  and TXUSRG is TXU surge plan
export const TXU_CLIENTIDS = ['TXUE', 'TXUE2'];
export const CE_PLAN = 'CE';
export const TXUCE_PLAN = 'TXUCE';
export const EMPLYD_CLIENT = 'EMPLYD';
export const BYOP_CUSTOMER_PHONE = '8444392636';
export const CE_CUSTOMER_PHONE = '8886657643';
export const TXU_CUSTOMER_PHONE = '8662438617';
export const CINCH_CUSTOMER_PHONE = '8443245688';
export const REMAX_CUSTOMER_PHONE = '8664080740';
export const REMAX_LOGO_ID = 252;

export const WARRANTY_SHORT_LABEL = 'WRNTY';
export const YES_RESPONSE = 'Y';
export const NO_RESPONSE = 'N';
export const MONTH_FREE = 'MONTH_FREE';


export const UserMenu = [
  {
    label: 'user Name',

    items: [
      {
        separator: true
      },
      {
        label: MENU_LABELS.payments,
        icon: 'pi pi-credit-card',
        route: '/payments'
      },
      {
        separator: true
      },
      {
        label: MENU_LABELS.profileSettings,
        icon: 'pi pi-cog',
        route: '/profile'
      },
      {
        separator: true
      },
    ]
  }
];

export const CLIENT_CONTACT_NUMBERS: Record<string, string> = {
  'FRDMMG': '8443247213',
  'SEARS': '8552562467',
  'SHW': '8552562467',
  'HMS': '8004321033',
  'GHP': '8448380562',
  'GHS': '8448380562',
  'GHW': '8448380562',
  'SAMS': '8662294584',
  'SCHW': '8662294584',
  'ALLSTE': '8553240950',
  'TXUE': '8662438617',
  'TXU': '8662438617',
  'CINDTC': '8662304983',
  'MADECC': '8004761705', // MADECC client contact number to be used for all Service Request related calls
  'MOEN': '8442291393',
  'SIRVA': '8339922624'
};

export const LF_CLIENT = 'L&F';
export const LF_CLIENT_CONTACT_NUMBER = '8777105095';

export const BALANCE_DUE_TOAST_MESSAGE = "To avoid delays or service interruptions please pay any due balance.";
export const BALANCE_DUE_STATUS = "Balance due";
export const BALANCE_DUE_MESSAGE = "Your payment is overdue.";
export const PAYMENT_IN_PROCESS_STATUS = "Payment in process";
export const NO_DUE_MESSAGE = "There is no payment due at this time."
export const NEXT_PAYMENT_MESSAGE = "Your next payment will be processed on:"
export const CHARGES_PAID_MESSAGE = 'Your monthly charges have been paid.'

export const COVERAGE_GROUP_P3 = 'P3';
export const CONTRACT_STATUS_EXPIRED = 'EXPIRED';
export const CONTRACT_STATUS_ACTIVE = 'ACTIVE';
export const MAX_QUERY_LENGTH = '240';

export const PAST_DUE_BANNER_MESSAGE = 'Your account is past due.';
export const PAYMENT_PENDING_BANNER_MESSAGE = 'Thank you! Your payment is being processed.';

export const CARD_TYPES: { [cardType: string]: { type: string; src: string } } = {
  'visa': { type: 'visa', src: '/assets/logos/Visa.svg' },
  'msrcd': { type: 'msrcd', src: '/assets/logos/Mastercard.svg' },
  'amex': { type: 'amex', src: '/assets/logos/Amex.svg' },
  'discvr': { type: 'discvr', src: '/assets/logos/Discover.svg' },
  'unknown': { type: 'unknown', src: '/assets/logos/credit-card.svg' }
};

export const PAYMENTECH = 'PAYMENTECH';
export const ACH_AUTO = 'ACH-AUTO';

export const STATES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const THIRD_PARTY_VENDORS_LIST = ['ghw', 'shw', 'schw', 'txu'];

export const FOOTER_LINKS: IFooterLinks = {
  disclosures: {
    name: 'Disclosures',
    url: 'disclosure',
  },

  privacyPolicy: {
    name: 'Privacy Policy',
    url: 'privacy-policy',
  },
  termsOfUse: {
    name: 'Terms of Use',
    url: 'terms-of-use',
  },
  doNotSell: {
    name: 'Do Not Sell or Share My Personal Information',
    url: environment.footerBaseUrl.doNotSellUrl + '?page_name=partner'
  }
};


export const SR_RECURSIVE_CALL_MAX_ATTEMPTS = 10;
export const SR_RECURSIVE_CALL_TIMEOUT = 5000;

export const SELECT_PAYMENT_OPTION_MESSAGE = 'Please select a payment option to continue.';

export const PAYMENT_TYPE_CREDIT_CARD = 'PAYMENTECH';
export const PAYMENT_TYPE_BANK_ACCOUNT = 'ACH-AUTO';

export const LIFERAY_CONTENT_KEY_PAST_DUE_CC = 'paymentech_for_pastDue';
export const LIFERAY_CONTENT_KEY_PAST_DUE_BA = 'ach-auto_for_pastDue';

export const PAYMENT_FLOW_CANCEL_PLAN = 'cancelPlan';
export const PAYMENT_FLOW_PAST_DUE = 'pastDue';
export const PAYMENT_FLOW_SR_INITIATION = 'serviceRequestInitiation';
export const PAYMENT_FLOW_SR_DETAIL = 'serviceRequestDetail';

export const CARD_TYPE_SAVED = 'savedCard';
export const CARD_TYPE_NEW = 'newCard';
export const ACC_TYPE_NEW = 'newBankAccount';
export const PAZE = 'paze';
export const REPLACEMENT_DEDUCTIBLE_PAYMENT_TYPE = 'RPL_DEDUCTIBLE_AMT';

export const CLAIM_ADJUSTMENT_AMOUNT = 'CLAIM_ADJUSTMENT_AMT';
export const DATE_FORMAT_FOR_API = 'MM/dd/yyyy';

export const CREDIT_CARD_LABEL = 'credit card';
export const BANK_ACCOUNT_LABEL = 'bank account';

export const CARD_NUMBER_REGULAR_REGEX = '^[0-9]+$';
export const CVV_REGULAR_REGEX = /(^[*]{3}$)|(^[\d]{3,5}$)/;
export const BANK_ACC_NO_REGEX = /^\d{6,17}$/;
export const BANK_ROUTING_NO_REGEX = /^\d{9}$/;
export const ZIP_CODE_REGEX = /^\d{5}$/;
export const ACCESS_TOKEN_LABEL = 'access_token';
export const LINK_BROKEN_ERROR_MESSAGE = 'Oops, something went wrong. That link seems to be broken or is expired.'
export const SOMETHING_WRONG_ERROR_MESSAGE = "Your service request status is temporarily unavailable. Please check back soon. We’re working to restore the information as quickly as possible.";
export const SELECTED_CONTRACT = 'selected_contract';
export const SELECTED_CONTRACT_DATA = 'selected_contract_data';
export const TUNNEL_HEADER_TITLE = {
  "serviceRequest": 'Service Request',
  "makePayment": 'Make Payment'
}

export const BENEFITS_COMMON = [
  'A plan that helps protect you from the rising costs of breakdowns',
  'A 6-month (180-day) workmanship guarantee on covered repairs',
  '24/7 service requests online or by phone',
];
export const BENEFITS_WITH_BYOP = [
  'Budget protection that helps with repair and replacement costs',
  'Coverage for unknown pre-existing conditions',
  'No age restrictions on appliances or systems',
];
export const BENEFITS_WITH_CE = [
  'Repair or replacement when your product requires service',
  '24/7 access to the tech support hotline to answer questions and resolve problems with your electronics (applies to Complete Home Entertainment and Home Office plans)',
  'No limit to the number of electronic products you can protect (multiple TVs, laptops, tablets, smart devices, etc.)',
  'Access to a network of pre-screened service providers and in-home service for TVs over 50 inches',
];


export const cancelServiceJobMessage = (
  serviceOrderId: string | undefined,
  isJobFFS: boolean = false
) => {
  const nonFFSMessage = `<p class="font-medium my-0 text-rose-700">Service request cancelled</p>
    <p class="my-1 font-normal text-rose-700 ">
      Service request #${serviceOrderId} has been cancelled. We are reviewing the details of your cancelled service request to determine if a refund is due for the service fee you paid toward your deductible. If you are due a refund, it will be processed in 5-7 days.
    </p>`;
  const ffsMessage = `<p class="font-medium my-0 text-rose-700">Service request cancelled</p>
    <p class="my-1 font-normal text-rose-700 ">
      Service request #${serviceOrderId} has been cancelled. We are reviewing the details of your cancelled service request to determine if a refund is due for the service fee you paid. If you are due a refund, it will be processed in 5-7 days.
    </p>`;
  return isJobFFS ? ffsMessage : nonFFSMessage;
}

export const serviceJobMessage = (brandPhone: string, custPhone: string, isAPOSPJob: boolean = false) => {
  return isAPOSPJob
    ? `For more information please contact <a href="tel:${brandPhone}" class="text-blue-700">${custPhone}</a>.`
    : `For more information or if you would like to cancel this service request, please call <a href="tel:${brandPhone}" class="text-blue-700">${custPhone}</a>.`;
}

export const SERVICE_ORDERID_NOT_FOUND_MESSAGE = 'The number entered is not found. Please check it and try again.';
export const UNABLE_TO_GET_SERVICEJOB_DETAILS_MESSAGE = 'We are unable to retrieve the status of your claim at this time. Please contact the phone number on your Welcome Kit for assistance.';
export const UNABLE_TO_CANCEL_SERVICEJOB_MESSAGE = 'We are unable to cancel the appointment due to an error. Please try again or please contact the phone number on your Welcome Kit for assistance.';
export const MICROWAVE_TYPES = [
  { name: 'Over the range' },
  { name: 'Built-in' },
  { name: 'Convection' },
  { name: 'Speedcook' },
  { name: 'Wall oven combo' },
];

export const DEFAULT_LOCATION = {
  LNDRY_RM: {
    name: "Laundry Room",
    value: "LNDRY_RM",
    related: "81",
    burkeId: null
  },
  KITCHEN: {
    name: "Kitchen",
    value: "KITCHEN",
    related: "81",
    burkeId: null
  },
  ONLY_UNIT: {
    name: "It's My Only Unit",
    value: "ONLY_UNIT",
    related: "127",
    burkeId: null
  },
  LIVING_AREA: {
    name: "Other Living Area",
    value: "ONLY_UNIT",
    related: "175",
    burkeId: null
  },
  BATHROOM: {
    name: "Bathroom",
    value: "MASTERBATH",
    related: "175",
    burkeId: null
  }
}

export const ERROR_MESSAGE_FOR_SELECTED_PRODUCT = 'Oops, there was an error getting data. Please try again or contact the phone number on your Welcome Kit for assistance.'
// prime ng table constants
export const DEFAULT_ROWS_PER_PAGE = 5;
export const PAGE_LINK_SIZE = 5;
export const ROWS_PER_PAGE_OPTIONS = [5, 10, 15];
export const CLAIM_HEADER_DEFAULT_TITLE = 'Select a service request to review details';

export const INITIAL_CREDIT_CARD_VALUE = {
  cardNumber: '',
  expirationMonth: '',
  expirationYear: '',
  expirationDateInput: '',
  firstName: '',
  lastName: '',
  typeCode: '',
  cvv: '',
};

export const INITIAL_BANK_ACCOUNT_VALUE = {
  accountNumber: '',
  routingNumber: '',
  accountTypes: '',
};

export const ERROR_MESSAGE_DEFAULT = 'Oops, there was an error. Please try again or contact us for assistance.';
export const WRONG_JOB_NUMBER_MESSAGE = 'The number entered is not found. Please check it and try again.';
export enum PhoneLabels {
  HOME = 'HOME',
  HOME1 = 'HOME1',
  MOBILE = 'MOBILE',
  OFFICE = 'OFFICE',
  OFFICE1 = 'OFFICE1'
}

export const CALL_FOR_UPDATE_PHONE_NUMBER = '+1 (844) 324-5688';


export const ERROR_MESSAGE_FOR_REVIEW_ERROR = (contactNumber: string, phoneNumber: string) => `Oops, we are having some trouble. Please try again or call customer service at <a href='tel:${contactNumber}'>&nbsp;${phoneNumber}</a>`;
export const ERROR_MESSAGE_FOR_MULTIPLE_ATTEMPTS = 'Failed to get submit data after multiple attempts.';

export const DEFAULT_SERVICE_REQUEST_HISTORY_COLS = [
  { label: 'Date', value: 'requestDateFormatUS' },
  { label: 'Service order #', value: 'serviceOrderId' },
  { label: 'Type', value: 'models.0.serviceRequestType' },
  { label: 'Item', value: 'models.0.productLineDescription' },
  { label: 'Status', value: 'jobDisplay.displayStatus' },
];

export const STATUS_TEXT_SPL_COVERAGE_GROUP = `For more information or if you would like to cancel this service request, please call`;
export const STATUS_TEXT_FOR_APOSP = `For more information please contact `;

export const ROOF_LEAK_SR_STATUS_MESSAGE = `Good News! To expedite your service request, you’ve been approved to select your own licensed and insured Service Professional. Please refer to the email instructions that were sent to your email on file from <a href="mailto:SupportingDocuments@Cinchhs.com" class="text-blue-700">SupportingDocuments@Cinchhs.com</a>.`;
export const ROOF_LEAK_SR_STATUS_CONTACT_TEXT = `For more information or to cancel this service request, please contact`;

export const SR_FLOW_STEPS = [
  { label: "one", id: "JI", title: "Service requested", isVisible: true },
  { label: "two", id: "CA", title: "Confirmed appointment", isVisible: true },
  { label: "three", id: "DC", title: "Diagnosis confirmed", isVisible: true },
  { label: "complete", id: "CMP", title: "Service completed", isVisible: true },
  { label: "cancel", id: "CAN", title: "Service cancelled", isVisible: false },
];
export const EDIT_ADDRESS_UPDATE_ERROR_MESSAGE = '<p class="font-medium my-0 text-rose-900">Oops! There was an error.</p><p class="my-1 font-normal text-rose-900 ">We couldn’t save your address please try again.</p>';
export const EDIT_Profile_INFO_UPDATE_SUCCESS_MESSAGE = '<p class="font-medium my-0 text-emerald-900">Updated profile.</p><p class="my-1 font-normal text-emerald-900 ">Your information was successfully updated.</p>';
export const EDIT_CONTACT_UPDATE_ERROR_MESSAGE = '<p class="font-medium my-0 text-rose-900">Oops! There was an error.</p><p class="my-1 font-normal text-rose-900 ">We couldn’t save your email please try again.</p>';
export const CONTACT_INFO_FETCH_ERROR_MESSAGE = 'Error occurred while fetching contract information';

export const TERMS_CONDITION_CQP = `<ul>
  <li>You will receive an email from donotreply@chasepaymentech.com to register with JP Morgan Concourse.</li>
  <li>You will then link a registered Zelle account or direct bank account to receive your electronic payment.</li>
  <li>Your funds will be electronically deposited in 1-3 business days.</li>
  <li>All electronic payments made by JP Morgan Concourse shall be subject to respective terms and conditions of the plan holder's financial institution for the transfer or receipt of electronic payments. Your financial institution may impose fees or limitations to electronic payments.</li>
  <li>If you elect to receive payment via JP Morgan Concourse but JP Morgan is unable to process the payment or you elect to receive a check instead, a check will be sent via USPS within 7-10 days.</li>
  <li>This payment is being tendered as full satisfaction of your claim. Your acceptance of payment pursuant to these terms and conditions shall be deemed final payment in full.</li>
  </ul>`;
export const TERMS_CONDITION_CHECK = `<ul>
  <li>It may take up to 7 to 10 business days to receive your check via USPS.</li>
  <li>This payment is being tendered as full satisfaction of your claim. Your acceptance of payment pursuant to these terms and conditions shall be deemed final payment in full.</li>
  </ul>`;

export const DISBURSEMENT_OPTIONS = [
  { label: 'JP Morgan Concourse', value: 'CQP', termsCondition: TERMS_CONDITION_CQP },
  { label: 'Check by mail', value: 'CHECK', termsCondition: TERMS_CONDITION_CHECK },
];

export const DISBURSEMENT_VALUE_CHECK = 'CHECK';

export const LABEL_REPLACEMENT = 'replacement';
export const CLAIM_TYPE_BUYOUT = 'BUYOUT';
export const CLAIM_TYPE_REPLACE = 'REPLACE';
export const CLAIM_TYPE_VOUCHER = 'VOUCHER';
export const SRG_TXU_DOWNLOAD_LINKS = {
  forSrg: {
    txuClient: 'https://cdn.cinchhomeservices.com/media/pdf/SRG-ClientID-TXUE-TXUE2-Claim-reimbursement-form.pdf',
    nonTxuClient: 'https://cdn.cinchhomeservices.com/media/pdf/SRG-All-states-Reimbursement-Claim-Form.pdf'
  },
  forTxuSrg: 'https://cdn.cinchhomeservices.com/media/pdf/TXUSRG-Claim-Reimbursement-Form.pdf'
};


export enum ConfirmationType {
  WITH_PAYMENT = 'WITHPAYMENT',
  NO_PAYMENT = 'NOPAYMENT',
  SURGE = 'SURGE',
  ROOF_LEAK = 'ROOFLEAK',
  BYOP = 'BYOP',
  ONETIME_COURTESY_NO_PAYMENT = 'ONETIMECOURTESYNOPAYMENT',
  ONETIME_COURTESY_WITH_PAYMENT = 'ONETIMECOURTESY',
  RECALL = 'RECALL',
  DEFAULT = 'DEFAULT',
  PREVENTATIVE_MAINTENANCE = 'PM',
  BUY_OUT = CLAIM_TYPE_BUYOUT,
  REPLACE = CLAIM_TYPE_REPLACE,
  VOUCHER = CLAIM_TYPE_VOUCHER,
}


export const AD_REQUEST_TYPE = [{
  key: 'replacement',
  label: 'Replacement',
  recommended: true,
  teaser: 'Due to the estimated cost of your repair and the age of your item, we will install a new item instead of repairing your existing one',
  learnMoreHeading: `We'll be replacing your item.`,
  learnMore: `<p>Once we've selected a replacement, we'll email you the model details.</p>
  <p>You will be responsible for confirming the dimensions will fit your existing space before installation.</p>
  <p>Note: Manufacturing backups and delivery delays continue to affect the overall replacement process. Please respond within the next 24 hours to increase the chance of securing your replacement item. We will provide you with an ETA at the time your order is placed and will reach out if the timing changes by more than 14 days.</p>
  `,
  learnMoreWithDeductibleHeading: `We'll be replacing your item, and a $` + `{_Replacement_deductible} replacement deductible will be charged.`,
  learnMoreWithDeductible: `<p>Once we have selected an appropriate replacement, you will receive an email detailing the replacement model information. You will be responsible for confirming the dimensions will fit the existing space.</p>
  <p>Note: Manufacturing backups and delivery delays continue to affect the overall replacement process. Please respond within the next 24 hours to increase the chance of securing your replacement item. We will provide you with an ETA at the time your order is placed and will reach out if the timing changes by more than 14 days.</p>
  `
},
{
  key: 'claimCredit',
  label: 'Claim Credit',
  recommended: false,
  teaser: 'If you would not like us to install a replacement, choose this option to receive a payout for this claim instead.',
  learnMoreHeading: 'Cinch Home Services will provide you with a cash payment instead of a replacement item. ',
  learnMore: `<p>Keep in mind that the claim credit is calculated using Cinch's cost to replace, which is typically less than retail pricing. However, the credit can be used toward any unit of your liking.</p>
<p>Please note: Mailed checks may take up to 7-10 business days.</p>
`,
  learnMoreWithDeductibleHeading: `Cinch Home Services will provide you with a cash payment instead of a replacement item, and an applicable $` + `{_Replacement_deductible} replacement deductible will be charged.`,
  learnMoreWithDeductible: `<p>Keep in mind that the claim credit is calculated using Cinch's cost to replace, which is typically less than retail pricing. However, the credit can be used toward any unit of your liking.</p>
<p>Please note: Mailed checks may take up to 7-10 business days.</p>`
}];

export const ERROR_MESSAGE_FOR_DUPLICATE_PRODUCTS = "You can not select the same item again.";
export const ERROR_MESSAGE_FOR_SAME_MODEL_AND_SERIAL = "Model must be different from the serial number.";
export const SOURCE_SYSTEM_NAME = 'MYACCOUNT';
export const SOURCE_SYSTEM_VERSION = '1.0';
export const ELIGIBILITY_ERROR_HEATING = 'You may call to request a Heating visit during the eligibility period, which starts August 15th through November 15th.';
export const ELIGIBILITY_ERROR_AC = 'You may call to request a Air Conditioning visit during the eligibility period, which starts February 15th through May 15th.';
export const ELIGIBILITY_ERROR_DEFAULT = 'There was a problem submitting the claim. Please resubmit your claim or call us for assistance using the phone number on your Welcome Kit.';
export const PM_HEATING_CATEGORY_ID = '3541';
export const PM_AC_CATEGORY_ID = '3542';
export const EXCEED_QUANTITY_ERROR = '10006';
export const APPOINTMENT_TAKEN_ERROR = '10100';
export const ELIGIBILITY_PERIOD_ERROR_CODE = '10019';

export const SURCHARGE_TEXT_FOR_MULTI_ITEMS =
  "Please note that a deductible will be due for each separate item you request service for. If multiple items are added to a service request, multiple deductible charges may be due.";
export const BYOP_SURCHARGE_TEXT_FOR_MULTI_ITEMS =
  "A deductible will apply to all service requests.";

export const CUSTOMER_RESOLUTION_STATUS = ['Customer Notified', 'Customer Acknowledged'];
export const REPLACEMENT_MAJOR_REPAIR = 'Replacement/Major Repair';
export const CUSTOMER_RESOLUTION_SUBTYPES = {
  SYSTEM_REPLACEMENT: {
    key: 'System Replacement',
    title: 'Cinch Replacement',
    customerOption: 'replacement',
  },
  COMPONENT_REPLACEMENT: {
    key: 'Component Replacement',
    title: 'Cinch Component Replacement',
    customerOption: 'replacement',
  },
  GENERAL_REPAIR: {
    key: 'General Repair',
    title: 'Cinch Repair',
    customerOption: 'repair',
  },
};


export const CX_ONE_CONFIG = {
  SCRIPT_URL: 'https://web-modules-de-na1.niceincontact.com/loader/1/loader.js',
  INIT_ID: '4971',
  GUIDE_INIT_ID: environment.cxOneGuideInitId,
  SCRIPT_ID: 'cxoneScript',
  CUSTOM_CSS: '[class^="WaitingQueueModal"] {display: none};'
}

export const CANCEL_LABEL = 'cancel';
export const TECHNICIAN_LABEL = 'technician';
export const NOT_CANCELLABLE_LABEL = 'non-cancellable';
export const ONETIME_COURTESY_MESSAGE = (contactNumber: string, formatPhone: string): string => {
  return `<p class="font-medium mt-0 mb-2 text-orange-900 text-sm">One-Time Courtesy Service Request</p>
        <p class="my-1 font-normal text-orange-900 text-sm line-height-3">Although we have not yet received your home warranty payment, we’re extending a one-time courtesy service request as part of your warranty plan benefits.</p>
        <br/>
        <p class="my-1 font-normal text-orange-900 text-sm line-height-3">Please select one item below to proceed with your service request.</p>
        </br>
        <p class="my-1 font-normal text-orange-900 text-sm">If you have any questions, please call us at <a class="phone custom-bold text-orange-900 no-underline" href="tel:${contactNumber}">${formatPhone}</a></p>`;
}

export enum DisplayStatus {
  confirmedAppointment = 'CNFAPP',
  diagnosisSubmitted = 'DIASUB',
  awaitingDiagnosis = 'AWTDIA',
  pendingAppointment = 'PENAPP',
  confirmedReturnVisit = 'CRTNAP',
  pendingReturnVisitAppointment = 'PRTNAP',
  partsOrdered = 'PRTORD',
  partsShipped = 'PRTSHP',
  repairReplacementConfirmed = 'RRCNFD',
  claimCreditAccepted = 'CCRACC'
}

export const MILESTONE_CONFIG_KEYS = {
  PARTS: 'PARTS',
  NEED_RESCHEDULE: 'I need to reschedule',
  DATE_MODAL: 'dateModal'
} as const;

export const PARTS_SOURCE_TYPES = {
  CINCH_SUPPLY: 'Cinch will supply',
  SERVICE_PRO: 'Service Pro'
} as const;


export const CLAIM_REIMBURSEMENT_SAVE_ERROR_MESSAGE = 'We are unable to save this data at the moment. Please try again.';

export const P_MESSAGE_CLOSE_LABEL = 'Close message';


export const SOCIAL_LINKS_DISABLED_CLIENTS = [
  ClientIdForLogos.sears,
  ClientIdForLogos.ghp
];
export const ALLOWED_ADD_COVERAGE_DAYS = 30;
export const CLIENT_ID = {
  SEARS: 'SEARS',
  HMS: 'HMS',
}

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const LOGIN_BUTTON_CLICKED_FLAG = 'isLoginButtonClicked';

export const MICROWAVE_TYPE_OVER_THE_RANGE = 'Over the range';
export const MICROWAVE_TYPE_BUILT_IN = 'Built-in';
export const MICROWAVE_TYPES_REQUIRE_IDENTIFIERS = [
  MICROWAVE_TYPE_OVER_THE_RANGE,
  MICROWAVE_TYPE_BUILT_IN,
] as const;


export const FFS_AMOUNT_LABEL = 'FFS_AMT';
export const TEXT_PREVENTATIVE_MAINTENANCE = 'preventive maintenance';
export const GET_ANSWERS_LABEL = 'Get answers';
export const GET_SOCIAL_LABEL = 'Get social';

export const VIVR_QUERY_PARAM_KEY = 'VIVR-MYA';
export const VIVR_PAYMENT_ALREADY_DONE = 'Past_due_payment_already_done';
export const VIVR_PAYMENT_URL_EXPIRED = 'Past_due_payment_URL_expired';
export const PROCURE_VENDOR_MESSAGE = "Service Provider assignment in progress";
export const PROCURE_VENDOR_MESSAGE_WITH_DAYS = PROCURE_VENDOR_MESSAGE + " - you'll be notified within <b>48 hours</b>";
export const COMPLETED_MESSAGE = "Your service request was completed.";
export const CANCELLED_MESSAGE = "Your service request has been cancelled.";
export const SR_INIT_URL_EXPIRED = 'SR_init_URL_expired';
export const SR_STATUS_URL_EXPIRED = 'SR_status_URL_expired';
export const UNAUTHORIZED = 'Unauthorized';

export const APOSP_ACCOUNT_NUMBERS = ['700001484', '73523'];

export const ARCHMI = 'ARCHMI';
export const EMBED = 'EMBED';
export const BILLONCE = 'BILLONCE';
export const BILLCLIENT = 'BILLCLIENT';
export const CLIENT_MADECC = 'MADECC';
export const SRCAND = 'SRCAND';
export const SRCMPD = 'SRCMPD';
export const CAN = 'CAN';
export const CMP = 'CMP';
export const PENDING_REPLACEMENT_DECISION_SUBSTATUS = 'PRD';
export const CLAIM_CREDIT_ACCEPTED_SUBSTATUS = 'CCA';
export const REVIEW_DIAGNOSIS_STATUS_CODE = 'RVWDIA';
export const CLAIM_CREDIT_PART_DESCRIPTION = 'claim credit accepted';
export const ALLSTATE = 'ALLSTE';
export const HABITAT_FOR_HUMANITY = 'H4H';

export const cancelRestrictedProvidersList = ['Whirlpool'];

export const RELOAD_ATTEMPT_KEY = 'dynamic_import_reload_attempt';
export const RELOAD_COOLDOWN_MS = 5000;

export const FFS_TYPE_DRYER_VENT_CLEANING = 'Dryer Vent Cleaning';
export const FIRST_TIME_USER = 'firstTimeUser';

export const AUTOMATIC_DECISIONING_ITEM_VALUES = ['96'];
export const ELECTRICAL_PLUMBING_ITEM_VALUES = ['110', '175'];

export const WHAT_IS_THE_ISSUE_ERROR_MESSAGE = (contactNumber: string, formatPhone: string): string => {
  return `<p class="m-0">We couldn't load your information. Please try again in a moment or contact our support team at <a class="phone text-blue-700" href="tel:${contactNumber}">${formatPhone}</a>.</p>`;
}

export const CANCEL_BALANCE_ERROR_MESSAGE = (formattedContactNum: string): string => {
  return `We couldn't load your information. Please try again or contact us for assistance at <a href=\"tel:${formattedContactNum}\" class="phone text-rose-900">${formattedContactNum}</a>.`;
}
export const REALESTATE_CANCEL_BALANCE_ERROR_MESSAGE = 'You can reach us Monday - Friday, 8:00am - 8:00pm EST.';
export const NORMAL_CLIENT_CANCEL_BALANCE_ERROR_MESSAGE = 'You can reach us Monday - Friday, 8:00am - 9:00pm EST, Saturday, 9:00am - 5:30pm EST.';

export const CANCEL_PLAN_ERROR_MESSAGE = (contactNum?: string): string => {
  const phoneLink = contactNum ? `<a href=\"tel:${contactNum}\" class="phone text-rose-900 white-space-nowrap">${new FormatPhonePipe().transform(contactNum)}</a>` : '';
  return phoneLink ? `We were unable to process your request. Please try again or contact us for assistance at ${phoneLink}.` : `We were unable to process your request. Please try again or contact us for assistance.`;
}
export const PAGE_SOURCE = {
  DASHBOARD: 'Dashboard',
  PAYMENTS: 'Payments',
  PROFILE: 'Profile',
  SERVICE_REQUESTS: 'Service Requests',
  MY_PLAN: 'My Plan',
  UNKNOWN: 'Unknown',
}

export const UPDATE_BILLING_ALERT = (pageSource: string = PAGE_SOURCE.DASHBOARD, target: string = APP_ROUTES.UPDATE_BILLING_DASHBOARD): IAlertCardContent => ({
  tagValue: 'Payment action required',
  title: 'Your payment details need to be updated. Without a valid payment method on file, your plan coverage may lapse, and you could face delays when you need service the most.',
  button: {
    name: 'Update billing',
    target,
    link: '',
    isExternal: false
  },
  pageSource
});

export const MADE_CC_FEATURES_BENEFITS = "MADE-CC-features-benefits";
export const HANDYMAN_FEATURES_BENEFITS_CA = "Handyman-features-benefits-CA";
export const HANDYMAN_FEATURES_BENEFITS_OTHER_STATES = "Handyman-features-benefits";
export const HANDYMAN_ITEM_CODE = 'HNDYMN100';
export const WHOLESALE_CLUB_FEATURES_BENEFITS_CA = "Wholesale-club-features-benefits-CA";
export const WHOLESALE_CLUB_FEATURES_BENEFITS_OTHER_STATES = "Wholesale-club-features-benefits";
export const WHOLESALE_CLUB_ITEM_CODE = 'CLBMBRSP';
export const LOCKSMITH_FEATURES_BENEFITS = "Locksmith-reimbursement-resource";

// A/B testing related constants
export const CROSS_SELL_CE_EXPERIMENT_ID = '5363303671660544';
export const CROSS_SELL_CE_FORM_VARIANT_ID = '4547971172270080';
export const CROSS_SELL_CE_ENROLLMENT_VARIANT_ID = '6297043587563520';
export const CROSS_SELL_CE_CARD_THEME_EXPERIMENT_ID = '5729108200521728';
export const CROSS_SELL_CE_CARD_LIGHT_VARIANT_ID = '6364586595581952';
export const CROSS_SELL_CE_CARD_DARK_VARIANT_ID = '4545718176710656';

export const APPLIANCE_BUYLINE_GE_STORE_URL = 'https://www.myapstore.com/GEStore/Appliances/Registration';
export const PARTNER_PAGE_NAME_PARAM = '?page_name=partner';
export const APPLIANCE_BUYLINE_FOOTER_LINKS: { name: string, url: string }[] = [
  {
    name: FOOTER_LINKS.termsOfUse.name,
    url: `${environment.footerBaseUrl.withHeaderLink}terms-of-use${PARTNER_PAGE_NAME_PARAM}`,
  },
  {
    name: FOOTER_LINKS.disclosures.name,
    url: `${environment.footerBaseUrl.withHeaderLink}disclosure${PARTNER_PAGE_NAME_PARAM}`,
  },
  {
    name: FOOTER_LINKS.privacyPolicy.name,
    url: `${environment.footerBaseUrl.withHeaderLink}privacy-policy${PARTNER_PAGE_NAME_PARAM}`,
  },
  {
    name: FOOTER_LINKS.doNotSell.name,
    url: `${environment.footerBaseUrl.doNotSellUrl}${PARTNER_PAGE_NAME_PARAM}`,
  },
];
export const BRAND_CODES = {
  'GE': 'GE',
  'WHRPL': 'WHRPL',
};

export const TCAPI_WEB = 'TCAPI_WEB';
export const CSVK_CODES = ['CSVK11930', 'CSVK14300'];
export const CSVF10105 = 'CSVF10105';

/*
    "BUYER_CONVERSION": "BCW",
    "BUYER_DIRECT": "BDW",
    "NEW_HOME": "NHW",
    "OPEN_DIRECT": "ODW",
    */
export const BCW = 'BCW';
export const BDW = 'BDW';
export const NHW = 'NHW';
export const ODW = 'ODW';

export const AUTHORIZE_PAYMENT_FOR_CROSS_SELL_SCENARIO = 'authorize_payment_for_cross_sell';
export const CONTACT_CONSENT_FOR_CROSS_SELL_SCENARIO = 'consent_contact_for_cross_sell';

export const CONTACT_INFO_CONFIRMED = "Your contact information is up to date.";
export const CONTACT_INFO_CONFIRMED_CONSENT_NOT_CHECKED = "Your contact information is up to date. Please update your marketing communications preferences in your ";
export const CONTACT_INFO_CONFIRMED_CONSENT_ERROR = "Your contact information is up to date. We couldn't save your marketing communication preferences. Update them anytime in ";

export const STARTING_SOON_STATUS_LABEL = 'Starting soon';
export const STARTING_SOON_TAG_ICON = 'pi pi-clock text-blue-900 text-xs';
export const STARTING_SOON_TAG_BG_CLASS = 'text-blue-900 bg-blue-100 border-blue-200 font-normal text-sm md:text-base';
export const STARTING_SOON_TOAST_TITLE = '<strong>Thanks for choosing us!</strong>';
export const getStartingSoonToastMessage = (coverageStartDate: string): string =>
  `Your coverage starts <strong>${coverageStartDate}</strong>. We’ll be ready to help when you need us.`;

export const CONTACT_REASONS = {
  EXISTING_SERVICE_JOB: 'Existing service job',
  NEW_SERVICE_JOB: 'New service job',
  PLAN_BILLING: 'Plan billing',
  PLAN_COVERAGE: 'Plan coverage'
};

export const CONTACT_REASON_OPTIONS = [
  { label: CONTACT_REASONS.EXISTING_SERVICE_JOB, value: CONTACT_REASONS.EXISTING_SERVICE_JOB },
  { label: CONTACT_REASONS.NEW_SERVICE_JOB, value: CONTACT_REASONS.NEW_SERVICE_JOB },
  { label: CONTACT_REASONS.PLAN_BILLING, value: CONTACT_REASONS.PLAN_BILLING },
  { label: CONTACT_REASONS.PLAN_COVERAGE, value: CONTACT_REASONS.PLAN_COVERAGE }
];

export const REASON_OPTIONS = CONTACT_REASON_OPTIONS;

export const CROSS_SELL_PRICE = '$19.99';
